// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionBadge_container__1md3T"};